import HighchartsDemo from "./highcharts-demo";

export default HighchartsDemo